import cx from "classnames";
import React from "react";

import WhiteCheck from "./white-check.svg";

type CheckboxProps = { isChecked: boolean };

export const Checkbox = ({ isChecked }: CheckboxProps) => (
  <div
    className={cx(
      "w-6 h-6 flex-none rounded-lg border border-black/35 flex justify-center items-center mr-3",
      isChecked ? "bg-black" : "bg-white",
    )}
  >
    <WhiteCheck />
  </div>
);
